import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid2,
  IconButton,
  Stack,
  Switch,
} from "@mui/material";
import DashboardLayout from "../../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../components/MaterialInput";
import MaterialBox from "../../../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import MaterialButton from "../../../../../components/MaterialButton";
import DashboardFooter from "../../../../../layoutcontainers/DashboardLayout/components/Footer";
import {
  fetchData,
  fetchDataById,
  postData,
  putData,
} from "../../../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../../../reducers/formReducer";
import MaterialSelect from "../../../../../components/MasterSelect";
import { useSnackbar } from "../../../../../context/popup";
import { useLoading } from "../../../../../components/Loading";

const initialState = {
  MotorModel: {},
  MotorModelErr: "unchecked",
  insurerMake: {},
  insurerMakeErr: "unchecked",
  generalInsurer: {},
  generalInsurerErr: "unchecked",
  code: "",
  codeErr: "unchecked",
  name: "",
  nameErr: "unchecked",
  active: false,
};

const AddInsurerModel = () => {
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const [state, dispatch] = useReducer(handelChange, initialState);
  const [dropdown, setDropdown] = useState({
    makeId: [],
    insurer: [],
    modelId: [],
  });

  const [searchParams] = useSearchParams();
  const Id = searchParams.get("id");
  const pageType = searchParams.get("pageType");

  const pageMode =
    pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

  useEffect(() => {
    const fetchInsurerList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(
          `/reference/general/insurer-master?dropdown=true`
        );

        setDropdown((prev) => ({
          ...prev,
          insurer: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.companyName,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };
    const fetchMotorModelList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/motor/mmv/models?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          modelId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    const fetchInsurerMake = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/insurer/make?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          makeId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };
    fetchInsurerList();
    fetchMotorModelList();
    fetchInsurerMake();
  }, []);

  useEffect(() => {
    const fetchCountryById = async () => {
      setCircleLoading(true);
      try {
        const data = await fetchDataById(`/reference/insurer/model/${Id}`);
        const responseData = data?.data?.model;

        if (data?.success) {
          dispatch({
            type: "bulkUpdate",
            payload: {
              generalInsurer: {
                value: responseData?.gInsurerId,
                label: responseData?.gInsurerName,
              },
              MotorModel: {
                value: responseData?.mModelId,
                label: responseData?.mModelName,
              },
              insurerMake: {
                value: responseData?.iMakeId,
                label: responseData?.iMakeName,
              },
              code: responseData?.code,
              name: responseData?.name,
              active: responseData?.isActive,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching data by ID:", error);
      } finally {
        setCircleLoading(false);
      }
    };
    if (Id) {
      fetchCountryById();
    }
  }, [Id]);

  const handelSubmit = async () => {
    const payload = {
      gInsurerId: state?.generalInsurer?.value,
      code: state?.code,
      name: state?.name,
      mModelId: state?.MotorModel?.value,
      iMakeId: state?.insurerMake?.value,
      isActive: state?.active,
    };
    if (pageMode === "edit") {
      try {
        setCircleLoading(true);
        const response = await putData(`/reference/insurer/model/${Id}`, payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          window.history.back();
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    } else {
      try {
        setCircleLoading(true);
        const response = await postData("/reference/insurer/model", payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          window.history.back();
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;

    if (
      state.generalInsurerErr === "success" &&
      state.MotorModelErr === "success" &&
      state.insurerMakeErr === "success" &&
      state.codeErr === "success" &&
      state.nameErr === "success"
    ) {
      allowSubmit = false;
    } else {
      allowSubmit = true;
    }

    return allowSubmit;
  };
 

  return (
    <>
      <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton onClick={() => window.history.back()}>
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Model Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New Model Details from around the world.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
          />

          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    General Insurer <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="generalInsurer"
                  options={dropdown?.insurer}
                  value={state?.generalInsurer}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "generalInsurer",
                    })
                  }
                  success={state?.generalInsurerErr === "success"}
                  error={state.generalInsurerErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Motor Model <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.modelId}
                  value={state?.MotorModel}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "MotorModel",
                    })
                  }
                  success={state?.MotorModelErr === "success"}
                  error={state.MotorModelErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Insurer Make <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.makeId}
                  value={state?.insurerMake}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "insurerMake",
                    })
                  }
                  success={state?.insurerMakeErr === "success"}
                  error={state.insurerMakeErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Code <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="code"
                  value={state?.code}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "code",
                      type: "input",
                      regex: "^([\\s\\S]{1,20})$",
                    })
                  }
                  success={state?.codeErr === "success"}
                  error={state.codeErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.codeErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Code should be a minimum 1 character & maximum 20
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Name <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  value={state?.name}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "name",
                      type: "input",
                      regex: "^([\\s\\S]{1,60})$",
                    })
                  }
                  success={state?.nameErr === "success"}
                  error={state.nameErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.nameErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be a minimum 1 character & maximum 60
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Active
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={state?.active}
                      onChange={() =>
                        dispatch({
                          type: "switch",
                          name: "active",
                          value: !state?.active,
                        })
                      }
                      color="primary"
                      disabled={pageMode === "view"}
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {state?.active ? "Active" : "Inactive"}
                    </MaterialTypography>
                  }
                />
              </Grid2>
            </Grid2>
          </CardContent>
          <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {pageMode !== "view" && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="outlined"
                  color="dark"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={checkAllFields()}
                  onClick={handelSubmit}
                >
                  {pageMode === "add" ? "Submit" : "Edit"}
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </Card>
      </DashboardLayout>
      <DashboardFooter />
    </>
  );
};

export default AddInsurerModel;
